import { useTagsStore } from '@/feature/tags/store'

import { TagsPopoutView } from '../TagsPopoutView/TagsPopoutView.component'

export const GeofenceAlertTagsPopout = () => {
  const {
    isGeofenceTagsPopoutOpen,
    geofenceTagsPopoverPosition,
    closeGeofenceTagsPopout,
    globalOrgTags,
    geofenceAlertTags,
    setGeofenceAlertTags,
  } = useTagsStore()

  return (
    <TagsPopoutView
      popoverPosition={geofenceTagsPopoverPosition}
      closeTagsPopout={closeGeofenceTagsPopout}
      isTagsPopoutOpen={isGeofenceTagsPopoutOpen}
      tagsForSelection={globalOrgTags}
      storedTags={geofenceAlertTags}
      setStoredTags={setGeofenceAlertTags}
    />
  )
}
